// hooks/useRoles.js
import { useState, useEffect } from "react";

const useRoles = () => {
    const [roles, setRoles] = useState([]);

    useEffect(() => {
        const storedData = localStorage.getItem('user');
        const userDetails = storedData ? JSON.parse(storedData) : null;
        if (userDetails && userDetails.role) {
            setRoles(userDetails.role); // Assuming 'role' is the key where roles are stored and it's an array
        }
    }, []);

    return roles;
};

export default useRoles;
